import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withRouter } from "react-router-dom";
import { FormGroup, FormControl, ControlLabel, Button, Image, Col,Alert } from 'react-bootstrap';
import Icon from '../UI/Icon/Icon';

import mmkLogo from '../../assets/images/logo.png';
import showIcon from '../../assets/images/password-show.svg';
import hideIcon from '../../assets/images/password-hide.svg';
import errorIcon from '../../assets/images/error-exclamation-point.svg';
import checkValidIcon from '../../assets/images/password-check-valid.svg';
import checkInvalidIcon from '../../assets/images/password-check-invalid.svg';
import './passwordReset.css';
import Commonfooter from '../UI/FooterCommon/Commonfooter'
import ConsoleLog from '../../hoc/ConsoleLog/ConsoleLog';

/**
* @desc  Forget password for specific users
* @version 1.0.1
* @author  Lakshmikanth
*/
class PasswordResetForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      code: '',
      password: '',
      message: '',
      error: '', 
      errorPosition:"",     
      passwordView:false,
      verified:false
    };
    this.handleChangePassword = this.handleChangePassword.bind(this);
  }
/**
 * @desc save the resetpassword field with validations
 * @param event
 * @return null
 */
  onSubmit = (event) => {
    event.preventDefault();
    if(this.state.code.trim==''||this.state.password.trim==''){
      let errorPosition = [];      
      if(this.state.code.trim() ==''){
        
        errorPosition = errorPosition.concat('verification');
      }
      if (this.state.password.trim() ==''){
        errorPosition = errorPosition.concat('password');
      }  
       this.setState({
        errorPosition: errorPosition,error:''
      });
    }    
     else if(/^\d{6}$/.test(this.state.code)) {
        this.props.setPassword(this.state.username.trim().toLowerCase(), this.state.code, this.state.password)
        .then((response) =>{           
          this.setState({          
          error: '',
          code: '',
          password: '',
          message: 'New password successfully set!',
        })
        if(this.state.message==='New password successfully set!') {
          setTimeout(() => {
            this.props.history.push("/");
          }, 3000)
        }})
        .catch((err) => 
        {
          ConsoleLog('fp-err.code :'+err.code+': ,'+err.message+': ',err);
          if (err.code === 'UserNotFoundException') {
            this.setState({ message: '', error: 'User not found',errorPosition:"email" });
          } 
          else if (err.code === 'CodeMismatchException') {
            this.setState({ message: '', error: 'Invalid verification code provided, please try again.',errorPosition:"verification" })
          } 
          else if (err.code === 'InvalidPasswordException'|| err.code === 'InvalidParameterException') {
              this.setState({ message: '', error: 'Minimum password length is 8 characters. One uppercase, lowercase, number and a special character is required',errorPosition:"password" })
          } 
          else if (err.code === 'LimitExceededException') 
          {
            this.setState({ message: '', error: 'Attempt limit exceeded, please try after some time',errorPosition:"password" });
          } 
        });
      } 
      else {
            this.setState({ message: '', error: 'Invalid verification code provided, please try again.',errorPosition:"verification" });
      }
    
  }

  handleKeyPress = (e) => {
    var e = e || window.event; // for trans-browser compatibility
    var charCode = e.charCode || e.which || e.keyCode;                    
    if ((charCode > 31 && (charCode < 47 || charCode > 57)) ||this.state.code.length >= 6){
      e.preventDefault();
    }
    
    if (e.shiftKey) {
      e.preventDefault();
    } 
  }
/**
 * @desc Send verification to the filled email-id of user
 * @param event
 * @return null
 */
  sendVerificationCode = (event) => {
    event.preventDefault();
    if(this.state.username.trim() ==''){
      this.setState({errorPosition:'email'});
    }
    else{
    this.props.sendVerificationCode(this.state.username.trim().toLowerCase())
      .then(() => this.setState({
        message: 'Verification code successfully sent! Please check your email.',
        error: '',
        verified:true
      }))      

      .catch((err) => {
        ConsoleLog('error verfctn',err.code,err.message);
        if (err.code === 'UserNotFoundException') 
        {
          this.setState({ error: 'User not found', errorPosition:"email"});
        }
        else if (err.code === "InvalidParameterException") 
        {
          this.setState({ error: 'Invalid User Name' ,errorPosition:"email"});
        }  
        else if (err.code === "LimitExceededException") 
        {
          this.setState({ error: 'Attempt limit exceeded, please try after some time',errorPosition:"email" });
        }  
        else 
        {
          this.setState({ error: err.message ,errorPosition:"verification"})
        }
      });
    }
  }
/**
 * @desc Fill the reset-password field
 * @param event
 * @return null
 */
  changePassword = (event) => {
    this.setState({ password: event.target.value, error:'', errorPosition:'' });
  }
/**
 * @desc Fill the verification-code field
 * @param event
 * @return null
 */
  changeCode = (event) => {
    this.setState({ code: event.target.value ,error:'', errorPosition:'',message:''
  });
  }
/**
 * @desc Fill the User-name field
 * @param event
 * @return null
 */
  changeUsername =(event) => {
    this.setState({ username: event.target.value, error:'', errorPosition:''});
  }
  /**
 * @desc Show/hide password
 * @param null
 * @return null
 */
  passwordView=()=>{
    this.setState({passwordView:!this.state.passwordView});
  }

   /**
   * @desc Fill new reset password
   * @param event
   * @return null
   */
  handleChangePassword = (event) => {
    const password = event.target.value.trim();
    this.setState({ password: password, error:'', errorPosition: ''});
  }


  render() {
    const { password } = this.state;
    const urlArray = window.location.href.split('/');
    const redirectUrl = (urlArray[3] === "recruiter") ? "/recruiter/account" : "/account";
    const isPasswordLength = (password && password.length >= 8) ? true : false;
    return (
      <div className="forgot-main">
      <div className="forgot-password-section">  
        <div className="forgot-password-wrapper paddingtop-80">
          <div className="forgot-password-container">            
            {/* <h2 className="text-center">Reset Your Password</h2> */}
              {!this.state.verified ?
                <div className="form-wrapper">
                  <div className="text-center">
                    <h3 className="forgot-pwd-title">Forgot Your Password?</h3> 
                    {/* <a ><Image src={mmkLogo} alt="logo" className="logo"/></a> */}
                    <div className="forgot-password-title-email">Enter your email address and we’ll send you a verification code to reset your password.</div>
                  </div>
                  { (this.state.message) ? 
                    <div className="success-alert">
                        {this.state.message}
                    </div>
                  : "" }
                  
                  <form onSubmit={this.sendVerificationCode}>
                    <FormGroup controlId="formControlsNameText">
                      <ControlLabel>Email Address*</ControlLabel>
                      <FormControl
                        id="formEventNameText"
                        label="User name"
                        placeholder="Enter Email"
                        fullWidth
                        helpertext="Please enter your username and you will receive a verification code through email."
                        onChange={this.changeUsername}
                        value={this.state.username}
                        className={(this.state.username.trim() ==''&& this.state.errorPosition=="email")? "invalid-error":(this.state.error && this.state.errorPosition =="email")? "invalid-error":"text-field"}
                        margin="normal"
                      />
                      <div className="error-alert">
                        { ( this.state.username.trim() ==''&& this.state.errorPosition=="email")? <p><img src={errorIcon} title="Error" /><span>Please enter your email</span></p>:
                        (this.state.error) ? 
                        <p><img src={errorIcon} title="Error" /><span>{this.state.error}</span></p>
                        : "" }
                      </div>
                    </FormGroup>
                    <Button type="submit" className="btn btn-lg" variant="raised" color="default">
                    Send Verification Code
                    </Button>
                    <p className="f-password"><Link to={redirectUrl} className="forgot-password-link">Go back to login </Link></p>

                    {/* <p className="p-policy">
                      <Commonfooter />
                    </p>   */}

                    <div className="clearfix"></div>
                  </form>
                </div>
              : 
              <div className="form-wrapper">
                <div className="text-center set-new-pwd-main"> 
                  {/* <a ><Image src={mmkLogo} alt="logo" className="logo"/></a> */}
                  <h1 className="set-password-title">Set New Password</h1>
                  <div className=" forgot-password-title">Enter Verification code and New Password.</div>
                </div>
                {/* <div className="error-alert">
                  { (this.state.code.trim() =='' && this.state.errorPosition.includes("verification")) ?
                      "Please enter verification-code"
                      :((this.state.password.trim() =='' && this.state.errorPosition.includes("password"))) ?
                      "Please enter password"
                      :(this.state.error ) ? 
                       this.state.error
                      : "" }
                </div> */}

                { (this.state.message) ? 
                    <div className="success-alert">
                      <Icon icon="set-password-white-tick-mark" className="pwd-success-alert" /> <span className="success-message-pwd">{this.state.message}</span>
                    </div>
                : "" }
                
                <form onSubmit={this.onSubmit}>
                  <FormGroup controlId="formControlsNameText">
                    <ControlLabel className="required">Verification Code</ControlLabel>                    
                    <FormControl
                      id="formEventNameText"
                      type="number"
                      placeholder="Enter verification code"
                      helpe="Please enter the verification code you received through email."
                      onChange={this.changeCode}
                      className={(this.state.code.trim() ==''&& this.state.errorPosition.includes("verification"))? "invalid-error":(this.state.error && this.state.errorPosition == "verification")? "invalid-error" : "text-field"}
                      value={this.state.code}
                      margin="normal"
                      onKeyPress={this.handleKeyPress}
                    />
                    <div className="error-alert">
                      { this.state.code.trim() ==='' && (this.state.errorPosition.includes("verification"))? 
                        <p>
                          <img src={errorIcon} title="Error" />
                          <span>Please enter verification-code</span>
                        </p>:
                        (this.state.errorPosition.includes("verification") && (this.state.error==="Invalid verification code provided, please try again.")) ?
                        <p>
                          <img src={errorIcon} title="Error" />
                          <span>{this.state.error}</span>
                        </p>
                        :null
                      }
                    </div>
                  </FormGroup>
                  <FormGroup controlId="formControlsPassword" className="form-password">
                    <ControlLabel className="required">Enter new password</ControlLabel>                    
                    <FormControl
                      id="formEventNameText"
                      label="Password"
                      placeholder="Enter new password"
                      type={(this.state.passwordView)?"text":"password"}
                      // onChange={this.changePassword}
                      onChange={this.handleChangePassword}
                      value={this.state.password}
                      className={(this.state.password.trim() ==''&& this.state.errorPosition.includes("password"))? "invalid-error":(this.state.error && this.state.errorPosition =="password") ? "invalid-error":"text-field"}
                      margin="normal"
                    />
                    <div className="forget-password-control " 
                      onClick={() => this.passwordView() }>
                      {this.state.passwordView?<img src={hideIcon}/>:<img src={showIcon}/>}
                    </div>
                    {/* <div className="error-alert">
                        { 
                          (this.state.code.trim() === '') && (this.state.errorPosition.includes("password"))?
                          <p>
                            <img src={errorIcon} title="Error" />
                            <span>Please enter password</span>
                          </p>: 
                          (this.state.code.trim() != '' && this.state.errorPosition.includes("password")?
                          <p>
                            <img src={errorIcon} title="Error" />
                            <span>{this.state.error}</span>
                          </p>:
                          "" )
                        }
                    </div> */}
                  </FormGroup>
                  <div className="validation-list-cont">
                    <div>You password must</div>
                    <ul className="validation-list">                    
                      { (isPasswordLength) ? 
                        <li className="validation-list--item"><img src={checkValidIcon} title="Error" />Be minimum 8 characters</li>
                      : <li className="validation-list--item validation-list--item---invalid"><img src={checkInvalidIcon} title="Error" />Be minimum 8 characters</li> }
                    </ul>
                  </div>
                  <Button type="submit" className="btn btn-lg" variant="raised" color="default">
                  Set New Password
                  </Button>
                  <p className="f-password"><Link to={redirectUrl} className="forgot-password-link">Go back to login</Link></p>
                  {/* <p className="p-policy">
                      <Commonfooter />
                  </p>   */}
                  <div className="clearfix"></div>
                </form>
              </div>
              }
          </div>
        </div>
      </div>
      <div className="p-policy">
          <Commonfooter />
      </div>
      </div>
    )
  }
}
PasswordResetForm.propTypes = {
  error: PropTypes.string,
  username: PropTypes.string,
  sendVerificationCode: PropTypes.func,
  setPassword: PropTypes.func,
};

export default withRouter(PasswordResetForm);


// WEBPACK FOOTER //
// ./src/components/Authentication/PasswordResetForm.js